import { EntityVm } from 'api/core/entity.vm';
import { IsString } from 'class-validator';

export class ClientVm extends EntityVm {
  @IsString()
  name: string;
}
